import { render, staticRenderFns } from "./CustomPayment.vue?vue&type=template&id=37157d36&"
import script from "./CustomPayment.vue?vue&type=script&lang=js&"
export * from "./CustomPayment.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports